class EstimatedDelivery extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			date: ".estimated-delivery__date",
			variantSelector: ".form__width input[name=id]",
			variantsInventoryItems: ".variants-inventory > p",
			destinationRange: ".destination-range",
			uaeDataDelivery: ".estimated-delivery__destinations input.delivery-range-uae",
			gccDataDelivery: ".estimated-delivery__destinations input.delivery-range-gcc",
			restOfTheWorldDelivery: ".estimated-delivery__destinations input.delivery-range-rest",
			productForm: 'form[data-product-form].product-form'
		};

		this.months = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];
		this.elements = {
			uaeDataOptimisticDelivery: this.querySelector(this.selectors.uaeDataDelivery).dataset.optimisticDelivery,
			uaeDataPesimisticDelivery: this.querySelector(this.selectors.uaeDataDelivery).dataset.pesimisticDelivery,
			gccDataOptimisticDelivery: this.querySelector(this.selectors.gccDataDelivery).dataset.optimisticDelivery,
			gccDataPesimisticDelivery: this.querySelector(this.selectors.gccDataDelivery).dataset.pesimisticDelivery,
			restDataOptimisticDelivery: this.querySelector(this.selectors.restOfTheWorldDelivery).dataset.optimisticDelivery,
			restDataPesimisticDelivery: this.querySelector(this.selectors.restOfTheWorldDelivery).dataset.pesimisticDelivery,
		}

		this.inventory = {};
		this.shippingTime = {
			uae: [parseInt(this.elements.uaeDataOptimisticDelivery), parseInt(this.elements.uaeDataPesimisticDelivery)],
			gcc: [parseInt(this.elements.gccDataOptimisticDelivery), parseInt(this.elements.gccDataPesimisticDelivery)],
			world: [parseInt(this.elements.restDataOptimisticDelivery), parseInt(this.elements.restDataPesimisticDelivery)],
		};

		this.init();

		document.addEventListener("theme:variant:change", () => this.init());
	}
	init(){
		
		this.getVariantsInventory();
		this.getEstimations();
	}

	getVariantsInventory() {
		this
			.querySelectorAll(this.selectors.variantsInventoryItems)
			.forEach((variant) => {
				const variantId = variant.children[0].textContent;
				const variantStock = +variant.children[1].textContent;
	
				this.inventory[variantId] = variantStock;

			});
	}

	getSelectedVariant() {
		// Build selected variant using all selected options
		// Return in a readable way so we can locate it by name
		let selectedOptions;

		selectedOptions = document
			.querySelector(this.selectors.variantSelector).value;
		console.log(selectedOptions);
		return selectedOptions;
	}

	getEstimations() {
		const selectedVariant = this.getSelectedVariant();
		const isVariantInStock = this.inventory[selectedVariant] > 0;
		const productionTime = isVariantInStock ? [0, 0] : [10, 14]; // 0 days for items in stock and 7-10 days for made to order items

		let today = new Date();

		let deliveryDates = [];

		this
			.querySelectorAll(this.selectors.destinationRange)
			.forEach((el, i) => {
				const region = el.dataset.destination;
				
				const optimisticShippingDays = this.shippingTime[region][0];
				const pessimisticShippingDays = this.shippingTime[region][1];
				
				const optimisticDeliveryDate = this.calculateDeliveryDate(
					today,
					productionTime[0],
					optimisticShippingDays
				);

				const pessimisticDeliveryDate = this.calculateDeliveryDate(
					today,
					productionTime[1],
					pessimisticShippingDays
				);

				const optimisticFinal = this.formatDate(optimisticDeliveryDate);
				const pesimisticFinal = this.formatDate(pessimisticDeliveryDate);

				function splitDate(dateString) {
					const [day, month] = dateString.split(' ');
					return { day: parseInt(day), month };
				}

				const optimisticDate = splitDate(optimisticFinal);
				const pessimisticDate = splitDate(pesimisticFinal);

				if (optimisticDate.day === pessimisticDate.day) {
					pessimisticDate.day += 1;
				}

				const updatedPessimisticFinal = `${pessimisticDate.day} ${pessimisticDate.month}`;


				if(optimisticFinal == pesimisticFinal) {
					el.textContent = `${optimisticFinal} - ${updatedPessimisticFinal}`;
				} else {
					el.textContent = `${optimisticFinal} - ${pesimisticFinal}`;
				}
				
				let regionName = (Object.keys(this.shippingTime)[i]).toUpperCase();
				let deliveryDate = regionName + ' ' + el.textContent

				deliveryDates.push(deliveryDate);
			});

			const deliveryText = deliveryDates.join(" | ");
			this.addProductProprety(deliveryText);
	}

	addProductProprety(deliveryText){
		const productForm = document.querySelector(this.selectors.productForm);

		productForm.querySelector("input[name='properties[Estimated delivery]']")
			? productForm.querySelector("input[name='properties[Estimated delivery]']").remove()
			: '';

		if(deliveryText){
			const inputText = document.createElement('input');
			inputText.type = 'hidden';
			inputText.name = 'properties[Estimated delivery]';
			inputText.value = deliveryText;
			productForm.appendChild(inputText);
			productForm.setAttribute('data-product-additional-property-estimated-delivery', deliveryText);
		} else {
			productForm.removeAttribute('data-product-additional-property-estimated-delivery', '');
		}
		
	}



	calculateDeliveryDate(today, productionDays, shippingDays) {
		const outOfHours = today.getHours() > 16 ? 1 : 0;
		const totalDaysToAdd = productionDays + shippingDays + outOfHours;

		const deliveryDate = new Date(
			today.getTime() + totalDaysToAdd * 24 * 60 * 60 * 1000
		);

		const deliveryDateOusideWeekends = this.calculateWeekends(deliveryDate);

		return deliveryDateOusideWeekends;
	}

	calculateWeekends(today) {
		let cutoutDays = 0;

		switch (today.getDay()) {
			case 6: // Saturday
				cutoutDays += 2;
				break;
			case 0: // Sunday
				cutoutDays += 1;
			default:
				break;
		}

		return new Date(today.setDate(today.getDate() + cutoutDays));
	}

	formatDate(date) {
		return `${date.getDate()} ${this.months[date.getMonth()]}`;
	}
}

customElements.define("estimated-delivery", EstimatedDelivery);
